<template>
    <div>
        <div v-if="isAccountLoaded">
            <AIAHeaderText
                :headerText="headerText"
                :showSearch="showSearch"
                :modalController="modalController"
                @clickBack="clickBack()" />

            <slot name="content"></slot>

            <AIAFootMenu
                :pageName="pageName"
                :modalController="modalController" />
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
// component
import AIAHeaderText from "@/components/Layout/header/AIAHeaderText.vue";
import AIAFootMenu from "@/components/Layout/footer/AIAFootMenu.vue";
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
export default {
    name: 'RewardLayout',
    components: {
        AIAHeaderText,
        AIAFootMenu,
        ModalMaster
    },
    props: {
        headerText: { type: String },
        showSearch: { type: Boolean, default: false },
        pageName: { type: String },
        isAccountLoaded: { type: Boolean },
        modalController: { type: Object, required: true }
    },
    methods: {
        clickBack: function () {
            this.$emit('clickBack');
        }
    }

}
</script>
